<template>
  <div class="container-fluid px-4 mt-4">
    <!-- Bütün sayfayı kaplayan loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <div class="row" v-show="!loading">
      <!-- ÜRÜN LİSTESİ -->
      <div class="container">
        <vue-good-table
            mode="remote"
            @on-column-filter="onColumnFilter($event.columnFilters)"
            @on-page-change="onPageChange"
            @on-per-page-change="onPerPageChange"
            :rows="rows"
            :columns="columns"
            :totalRows="totalRecords"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              perPage: serverParams.perPage,
              perPageDropdown: [5, 10, 20],
              dropdownAllowAll: false,
              mode: 'records',
              nextLabel: 'Sonraki',
              prevLabel: 'Önceki',
              rowsPerPageLabel: 'Sayfa başına satır',
              ofLabel: '/',
              pageLabel: 'sayfa',
              allLabel: 'Tümü'
            }"
        >
          <template slot="table-actions">
            <b-button variant="success" @click="showReportModal = true">
              PDF İndir
            </b-button>
          </template>
        </vue-good-table>
      </div>
    </div>
    <b-modal
        id="reportModal"
        title="PDF Rapor İndir"
        v-model="showReportModal"
        hide-footer
    >
      <b-form @submit.prevent="downloadReport">
        <b-form-group label="Başlangıç Tarihi" label-for="start-date">
          <b-form-datepicker
              id="start-date"
              v-model="reportForm.from"
              required
              placeholder="Başlangıç Tarihi seçiniz"
          ></b-form-datepicker>
        </b-form-group>

        <b-form-group label="Bitiş Tarihi" label-for="end-date">
          <b-form-datepicker
              id="end-date"
              v-model="reportForm.to"
              required
              placeholder="Bitiş Tarihi seçiniz"
          ></b-form-datepicker>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
              v-model="reportForm.showDescriptions"
          >
            Fatura isimlerini göster
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
              v-model="reportForm.showDetails"
          >
            Faturalardaki hizmet/ürün kalemlerini göster
          </b-form-checkbox>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button variant="secondary" @click="showReportModal = false">
            İptal
          </b-button>
          <b-button variant="primary" type="submit" class="ml-2" :disabled="!reportForm.from || !reportForm.to">
            İndir
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import ClientService from '../../service/ClientService';

export default {
  name: 'transaction-history-list',
  data() {
    return {
      totalRecords: 0,
      rows: [],
      columns: [
        {field: 'id', hidden: true},
        {label: 'İşlem Türü', field: 'transactionType', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'Açıklama', field: 'description', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'İşlem Tarihi', field: 'date', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'Borç', field: 'debt', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'Alacak', field: 'credit', tdClass: 'text-center', thClass: 'text-center', sortable: false},
        {label: 'Bakiye', field: 'balance', tdClass: 'text-center', thClass: 'text-center', sortable: false},
      ],
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 10
      },
      basket: [],
      loading: false,
      quantitySelections: {},
      showImageModal: false,
      selectedImageUrl: null,
      showReportModal: false,
      reportForm: {
        from: null,
        to: null,
        showDescriptions: false,
        showDetails: false,
      },
    };
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems(this.serverParams);
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems(this.serverParams);
    },

    onColumnFilter(params) {
      this.updateParams({ columnFilters: params });
      this.loadItems(this.serverParams);
    },

    async loadItems(params) {
      this.loading = true;
      try {
        const response = await ClientService.getTransactionHistory(this.$store.state.clientId, params.perPage, params.page);
        this.rows = response.data;
        this.totalRecords = response.totalCount;
      } catch (error) {
        console.error("Listeleme sırasında hata:", error);
      } finally {
        this.loading = false;
      }
    },

    async downloadReport() {
      this.loading = true;
      try {
        const payload = {
          clientId: this.$store.state.clientId,
          from: this.reportForm.from,
          to: this.reportForm.to,
          show_descriptions: this.reportForm.showDescriptions,
          show_details: this.reportForm.showDetails
        };
        const downloadUrl = await ClientService.getTransactionHistoryReport(payload);

        const link = document.createElement('a');
        link.href = downloadUrl;
        link.target = '_blank';
        link.setAttribute('download', 'IslemGecmisi.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('PDF indirme hatası:', error);
        this.$errorNotification(this, "Pdf indirilirken hata oluştu. Lütfen daha sonra tekrar deneyiniz.");
      } finally {
        this.showReportModal = false;
        this.loading = false;
      }
    },
  },
  beforeMount() {
    this.loadItems(this.serverParams);
  }
};
</script>

<style scoped>

</style>
